import { authenticatedFetch } from "../utils/api";
import { API_HOST } from "../utils/constants";

const jsonOptions = (method, body) => ({
  method,
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(body || {}),
});

export const listAssistantConversations = (projectId) => {
  const query = new URLSearchParams();
  if (projectId != null && projectId !== "") query.set("projectId", projectId);
  return authenticatedFetch(`${API_HOST}/api/assistant/conversations${query.size ? `?${query}` : ""}`);
};

export const createAssistantConversation = ({ projectId, title } = {}) =>
  authenticatedFetch(`${API_HOST}/api/assistant/conversations`, jsonOptions("POST", { projectId, title }));

export const updateAssistantConversation = (conversationId, patch) =>
  authenticatedFetch(
    `${API_HOST}/api/assistant/conversations/${encodeURIComponent(conversationId)}`,
    jsonOptions("PATCH", patch),
  );

export const archiveAssistantConversation = (conversationId) =>
  authenticatedFetch(`${API_HOST}/api/assistant/conversations/${encodeURIComponent(conversationId)}`, {
    method: "DELETE",
  });

export const listAssistantMessages = (conversationId) =>
  authenticatedFetch(`${API_HOST}/api/assistant/conversations/${encodeURIComponent(conversationId)}/messages`);

export const clearAssistantMessages = (conversationId) =>
  authenticatedFetch(`${API_HOST}/api/assistant/conversations/${encodeURIComponent(conversationId)}/messages`, {
    method: "DELETE",
  });

export const listAssistantSkills = (projectId) => {
  const query = new URLSearchParams();
  if (projectId != null && projectId !== "") query.set("projectId", projectId);
  return authenticatedFetch(`${API_HOST}/api/assistant/skills${query.size ? `?${query}` : ""}`);
};

export const importAssistantSkill = ({ file, scope = "user", projectId }) => {
  const query = new URLSearchParams({ scope });
  if (projectId != null && projectId !== "") query.set("projectId", projectId);
  const body = new FormData();
  body.append("file", file);
  return authenticatedFetch(`${API_HOST}/api/assistant/skills/import?${query}`, {
    method: "POST",
    body,
  });
};

export const updateAssistantSkill = (skillId, patch) =>
  authenticatedFetch(
    `${API_HOST}/api/assistant/skills/${encodeURIComponent(skillId)}`,
    jsonOptions("PATCH", patch),
  );

export const deleteAssistantSkill = (skillId) =>
  authenticatedFetch(`${API_HOST}/api/assistant/skills/${encodeURIComponent(skillId)}`, {
    method: "DELETE",
  });

export const listConversationSkills = (conversationId) =>
  authenticatedFetch(`${API_HOST}/api/assistant/conversations/${encodeURIComponent(conversationId)}/skills`);

export const setConversationSkills = (conversationId, skillRefs) =>
  authenticatedFetch(
    `${API_HOST}/api/assistant/conversations/${encodeURIComponent(conversationId)}/skills`,
    jsonOptions("PUT", { skillRefs }),
  );
